import { Component, Emit, Prop, Vue } from 'vue-property-decorator';
import { Report } from '@/models/Report';
import Questionnaire from '@/components/Questionnaire/Questionnaire.vue';
import { DateFormatter } from '@/support/DateFormatter';
import { AxiosError } from 'axios';
import ErrorHandler from '@/support/ErrorHandler';

@Component<OverwriteApplicantDialog>({
  components: {
    Questionnaire,
  },
})
export default class OverwriteApplicantDialog extends Vue {
  @Prop()
  protected report!: Report;
  protected customApplicantEmail?: string;
  protected customApplicantPhone?: string;

  protected isLoading = true;


  protected async mounted(): Promise<void> {
    this.customApplicantEmail = this.report.custom_applicant_email;
    this.customApplicantPhone = this.report.custom_applicant_phone;
    this.isLoading = false;
  }

  protected close(): void {
    this.$emit('input', false);
  }

  protected async updateApplicant(): Promise<void> {
    if (! this.report) {
      return;
    }

    let payload = {
      custom_applicant_email: this.customApplicantEmail,
      custom_applicant_phone: this.customApplicantPhone,
    };

    await new Report(this.report).update(payload)
      .then(() => {
        this.$emit('applicant-updated');
        this.close();
      })
      .catch((error: AxiosError) => {
        ErrorHandler.network(error);
      });
  }

  protected get isValid(): boolean {
    return !! true;
  }
}